import React, { ReactNode } from 'react';
import './Tab.css';

interface TabProps {
  title: string;
  id: string;
  children: ReactNode;
}

const Tab: React.FC<TabProps> = ({ title, children }) => {
  return <div className="tab">{children}</div>;
};

export default Tab; 
